import React from "react";
import {ConstraintPluginProps} from "../ConstraintDataPlugin";
import {EnumerationConstraintDataDto} from "../../../../../../common/apis/datatype/DataTypeConstraintDto";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import {t} from "../../../../../../store/localization/TranslMessasge";
import MultiValueTextField from "../../../../../../components/fields/textfield/MultiValueTextField";
import {CoreDataType} from "../../../../../../common/apis/datatype/DataTypeDefinitionDto";
import Snackbar from "../../../snackbar/Snackbar";

export function EnumerationConstraintPluginForm({ data, coreDataType, onChange, errors }: Readonly<ConstraintPluginProps<EnumerationConstraintDataDto>>) {
    function validateNewEnumValue(newEnumValue: string): boolean {
        const trimmedValue = newEnumValue.trim();
        if (!trimmedValue) {
            return false;
        }

        const numericCoreTypes = [CoreDataType.INTEGER, CoreDataType.FLOAT, CoreDataType.CURRENCY];
        if (numericCoreTypes.includes(coreDataType) && !isNumber(trimmedValue)) {
            Snackbar.error(t(DataTypeTranslationKey.ENUMERATION_VALUE_MUST_BE_A_NUMBER));
            return false;
        }

        return true;
    }

    function isNumber(value: string): boolean {
        const numValue = value === '' ? 0 : parseFloat(value);
        return !isNaN(numValue);
    }

    const values = data.values.sort();

    return (
        <MultiValueTextField
                label={t(DataTypeTranslationKey.ENUMERATION_VALUES)}
                values={values}
                onChange={(newValues) => onChange({...data, values: newValues})}
                validateValueBeforeAdd={validateNewEnumValue}
                errorMessage={errors?.values}
                required={true} />
    );
}